import { render, staticRenderFns } from "./JZDetails.vue?vue&type=template&id=0106814b&scoped=true&"
import script from "./JZDetails.vue?vue&type=script&lang=js&"
export * from "./JZDetails.vue?vue&type=script&lang=js&"
import style0 from "./JZDetails.vue?vue&type=style&index=0&id=0106814b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0106814b",
  null
  
)

export default component.exports